export default {
    GET_STRING: {
        NAME: 'get_string',
        PATH: 'lang/get_string',
    },
};
